export const CUSTOM_DROPDOWN_VALUE_CHAR_LIMIT = 50;
export const CUSTOM_STATUS_NAME_CHART_LIMIT = 50;

export const DEFAULT_TASK_FIELD_COLOR = "#2196F3";
